import { render, staticRenderFns } from "./optional-products.vue?vue&type=template&id=910c766c&scoped=true&"
import script from "./optional-products.vue?vue&type=script&lang=js&"
export * from "./optional-products.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "910c766c",
  null
  
)

export default component.exports